export default __webpack_public_path__ + "static/media/how_to_choose_the_perfect_vessel.aa462e30.webp";